import { render } from "./SiteSetting.vue?vue&type=template&id=ed9c5378&scoped=true"
import script from "./SiteSetting.vue?vue&type=script&lang=js"
export * from "./SiteSetting.vue?vue&type=script&lang=js"

import "./SiteSetting.vue?vue&type=style&index=0&id=ed9c5378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed9c5378"]])

export default __exports__